
/**
 * buildCallYouFields
 * Builds the page-context fields[] array for the call-you payload.
 *
 * @param {object} [overrides={}] Optional key→value overrides.
 *   e.g. buildCallYouFields({ product: 'flight', origin: 'CDMX|...' })
 */
export function buildCallYouFields(overrides = {}) {
    const hotel = window.__pt?.hotel ?? {};
    const box   = window.__pt?.box   ?? {};
    const page = window.__pt?.settings?.page || 'generic';
    const culture = window.__pt.culture || window.__pt.cultureData;
    const pax      = box.pax || {};
    const children = (pax.children || []).join(',');
    const travelers = `ad:${pax.adults || 0}${children ? '-ch:' + children : ''}`;

    const defaults = {
        current_page:  window.location.href,
        destination:   hotel.location?.city ?? box.destination ?? '',
        origin:        '',
        start_date:    box.checkIn  ?? '',
        end_date:      box.checkOut ?? '',
        travelers,
        rooms:         String(pax.rooms ?? ''),
        product:       'hotel',
        product_step:  page,
        property_name: hotel.name    ?? '',
        property_id: String(hotel.hotelId ?? ''),
        nationality: culture.cultureCode,
    };

    const merged = { ...defaults, ...overrides };

    return Object.entries(merged).map(([key, value]) => ({ key, value }));
}

export async function submitCallYou({
    endpointUrl,
    csrfToken,
    firstName,
    phone,
    phonePrefix  = '',
    recaptchaToken = '',
    fieldOverrides = {},
}) {
    const email = window.__pt?.user?.userProfile?.contactEmail ?? '';

    const payload = {
        _token:          csrfToken,
        _recaptchaToken: recaptchaToken,
        contact_information: {
            first_name:   firstName,
            phone,
            phone_prefix: phonePrefix,
            email,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            fields: buildCallYouFields(fieldOverrides),
        },
    };

    return fetch(endpointUrl, {
        method:  'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body:    JSON.stringify(payload),
    });
}
